export default "__VITE_ASSET__9822e5a3__"